import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap';
import s from './ListHeader.css';

// Components
import Link from '../../Link';
import ListNavigation from './ListNavigation';
import SaveButton from './SaveButton';
import Logo from '../../Logo';
import Toaster from '../../Toaster';
import styled from 'styled-components';
import { Flex } from 'rebass';
import AddListingTimeline from '../../../components_new/listing/AddListingTimeline';
import steps from '../../../components_new/listing/ListingSteps';

class ListHeader extends React.Component {
  static propTypes = {
    step: PropTypes.number.isRequired,
    formPage: PropTypes.string.isRequired,
  };

  render() {
    const { step, formPage } = this.props;

    return (
      <div className={s.root}>
        <Toaster />
        <div className={s.container}>
          <Navbar
            fluid
            className={cx(s.rentAllHeader, 'ListHeader')}
            fixedTop={true}
            expanded={false}
          >
            <Navbar.Header>
              <Navbar.Brand>
                <Logo link={'/'} className={cx(s.brand, s.brandImg)} />
              </Navbar.Brand>
            </Navbar.Header>
            <Navbar.Collapse>
              <TimelineContainer
                justifyContent="center"
                alignItems="center"
              >
                <AddListingTimeline
                  steps={steps}
                  stepChanged={this.nextPage}
                  currentRoute={formPage}
                  values={{}}
                  editing={false}
                />
              </TimelineContainer>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ListHeader);

const TimelineContainer = styled(Flex)`
  height: 100%;
  margin-top: 9px;
  padding-left: 64px;
`;



// WEBPACK FOOTER //
// ./src/components/Header/List/ListHeader.js